import { UserDistricts } from "../models/userdistricts.model";
import { responseHero } from "../utils/axiosInterceptor";

export const fetchUserDistricts = (): Promise<UserDistricts[]> => {
    return new Promise<UserDistricts[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/cluster/districts`).then((response) => {
            resolve(response.data as UserDistricts[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};